<div class="banner" *ngIf="showBanner" role="region" aria-label="Download app banner" [ngStyle]="{ 'background': bannerBg, 'color': bannerText }">
  <div class="banner__content">
    <img class="banner__icon" src="assets/logo.png" alt="App Icon" width="44" height="44" />
    <div class="banner__info">
      <div class="banner__title">{{ appName }}</div>
      <div class="banner__subtitle">Available on {{ storeName }}</div>
    </div>
    <div class="banner__actions">
      <a class="banner__download" [href]="storeLink" target="_blank" rel="noopener noreferrer" [ngStyle]="{ 'background-color': bannerText, 'color': bannerBg }">
        Download
      </a>
      <button class="banner__close" type="button" (click)="dismissBanner()" aria-label="Dismiss download banner">✕</button>
    </div>
  </div>
</div>
